import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

import { AddEditHamodelComponent } from './addEditHamodel.component';

import { HamodelModel } from '../../../model/index';
import { HamodelService } from '../../../services/index';

@Component({
    selector: 'hamodel-tab',
    templateUrl: './hamodel.component.html',
})
export class HamodelMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public hamodeldata: any[] = [];
    pageCol:number = 80;
    isLoadMask: Promise<any>;
    hamodelData: HamodelModel[];
    isLoading: boolean = false;

    constructor(private hamodelService: HamodelService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'cb.name',
        orderDir: 'asc'
    };
    filterData={
        search_data:''
    }
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    ngOnInit(): void {
        //page_prop -- OWN VARIABLE
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'NAME', prop: 'name', width: 170, minWidth: 170, maxWidth: 170 },
            { name: 'BRAND', prop: 'brand_name', width: 120, minWidth: 120, maxWidth: 120, page_prop: 'Spare'},
            { name: 'MODEL', prop: 'model_name', width: 155, minWidth: 155, maxWidth: 155, page_prop: 'Spare' },
            { name: 'FAMILY', prop: 'family_name', width: 120, minWidth: 120, maxWidth: 120, page_prop: 'Spare' },
            { name: 'TAX %', prop: 'tax_per', width: 100, minWidth: 100, maxWidth: 100, cellClass: 'cell-right' },
            { name: 'MRP', prop: 'mrp', width: 100, minWidth: 100, maxWidth: 100, cellClass: 'cell-right' },
            { name: 'SERIES', prop: 'series_name', width: 100, minWidth: 100, maxWidth: 100, page_prop: 'Spare'},
            { name: 'PERFORMANCE', prop: 'performance_name', width: 135, minWidth: 135, maxWidth: 135, page_prop: 'Spare' },
            { name: 'POWER', prop: 'power_name', width: 100, minWidth: 100, maxWidth: 100, page_prop: 'Spare' },
            // { name: 'DESIGN', prop: 'design_name', width: 100, minWidth: 100, maxWidth: 100, page_prop: 'Spare'},
            { name: 'BATTERY', prop: 'battery_name', width: 100, minWidth: 100, maxWidth: 100, page_prop: 'Spare' },
            { name: 'COLOR', prop: 'color_name', width: 120, minWidth: 120, maxWidth: 120, page_prop: 'Spare' },
            { name: 'TELE AUDIOLOGY', prop: 'tele_audiology', width: 170, minWidth: 170, maxWidth: 170, page_prop: 'Spare' },
            //{ name: 'Warranty Period',prop:'warranty_type', width:170, minWidth: 170, maxWidth: 170, cellClass: 'cell-left' },
            { name: 'Action', prop: 'sno', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        if(this['params']['tabParams'] == 'Spare'){
            var evens = _.remove(this.columns, function(obj) {
                return obj['page_prop'] == 'Spare'
            });
        }

        this.pageCallback({ offset: 0 });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
            this.page.offset = pageInfo.offset;
            this.getHamodelList();
    }

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getHamodelList();
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getHamodelList();
    }
    applyFilter(){
        this.getHamodelList();
    }

    clearFilter(): void {
        this.filterData = {
            "search_data": ""
        };
        this.applyFilter();
    }

    getHamodelList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            from_page: this['params']['tabParams'],
            filter:this.filterData['search_data']
        };
        let that = this;
        this.isLoadMask = this.hamodelService
            .getHamodelList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.hamodelData = res.data;
            });
    }

    downloadCurrentData(): void {
        const propMap = {
            name: 'NAME', brand_name: 'BRAND', model_name: 'MODEL', family_name: 'FAMILY',
            tax_per: 'TAX %', mrp: 'MRP', series_name: 'SERIES', performance_name: 'PERFORMANCE',
            power_name: 'POWER', battery_name: 'BATTERY', color_name: 'COLOR', tele_audiology: 'TELE AUDIOLOGY'
        };
        const visibleProps = this.columns.filter(c => propMap[c.prop]).map(c => c.prop);
        let params = {
            start: '0', limit: '99999',
            orderColumn: `${this.page.orderBy}`, orderDir: `${this.page.orderDir}`,
            from_page: this['params']['tabParams'], filter: this.filterData['search_data']
        };
        this.hamodelService.getHamodelList(params).then((res: any) => {
            const rows = (res.data || []).map((r, i) => {
                let row: any = { 'SNo': i + 1 };
                visibleProps.forEach(p => { row[propMap[p]] = r[p]; });
                return row;
            });
            const ws = XLSX.utils.json_to_sheet(rows);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            XLSX.writeFile(wb, 'HA_Model_' + moment().format('DD-MM-YYYY') + '.xlsx');
        });
    }

    bsModalRef: BsModalRef;
    public onAddEditHamodel(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditHamodelComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        if(row==undefined){
            row=[];
        }
        row['mode'] = mode;
        row['from_page'] = this['params']['tabParams'];
        this.bsModalRef.content.title = mode + ' ' + this['params']['tabParams'] + ' Details';//' HA Model Details';
        //this.bsModalRef.content.mode = 'Add';
        //this.bsModalRef.content.hamodeldata = {};
        this.bsModalRef.content.hamodeldata = Object.assign({}, row);
        this.bsModalRef.content.haModelLoadEvent.subscribe(($e) => {
            that.getHamodelList();
        });
    }

    onDeleteHamodel(row: any): void {
        let that = this,
            data = {
                model_id: row.model_id,
                from_page: row.from_page
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover: ' + row.name + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.hamodelService
                .deleteHamodel(data)
                .then(function(res: any) {
                    if (res.success) {
                        that.getHamodelList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }

                });
        }, function(dismiss) {

        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/hamodel/hamodel.component.ts